import { ccv, crv, cva } from '@/styled-system/css';

export const buttonGroupRecipe = cva({
  base: {
    'display': 'flex',
    'position': 'relative',
    'zIndex': 1,

    '& > :where(a, button)': {
      'position': 'relative',
      'zIndex': 1,
      '&[aria-pressed="true"]': {
        zIndex: 2,
      },
      '&:focus': {
        zIndex: 3,
      },
    },
  },

  variants: {
    conjoined: {
      true: {
        '& > :where(a, button)': {
          '&:not(:first-child):not(:last-child)': {
            borderRadius: 'ButtonGroup.conjoined',
          },
        },
      },
      false: {},
    },

    ...crv('fluid', {
      true: {
        '& > :where(a, button)': {
          flexBasis: '100%',
          flexGrow: 1,
        },
      },
      false: {
        '& > :where(a, button)': {
          flexBasis: 'auto',
          flexGrow: 0,
        },
      },
    }),

    ...crv('orientation', {
      horizontal: {
        alignItems: 'start',
      },
      vertical: {
        alignItems: 'stretch',
      },
    }),

    ...crv('reverse', {
      true: {},
      false: {},
    }),
  },
  compoundVariants: [
    ...ccv({
      orientation: 'horizontal',
      reverse: true,
      css: {
        flexDirection: 'row-reverse',
      },
    }),

    ...ccv({
      orientation: 'horizontal',
      reverse: false,
      css: {
        flexDirection: 'row',
      },
    }),

    ...ccv({
      orientation: 'vertical',
      reverse: true,
      css: {
        flexDirection: 'column-reverse',
      },
    }),

    ...ccv({
      orientation: 'vertical',
      reverse: false,
      css: {
        flexDirection: 'column',
      },
    }),

    ...ccv({
      conjoined: false,
      orientation: 'horizontal',
      css: {
        gap: 'ButtonGroup.gap.horz',
      },
    }),

    ...ccv({
      conjoined: false,
      orientation: 'vertical',
      css: {
        gap: 'ButtonGroup.gap.vert',
      },
    }),

    ...ccv({
      conjoined: true,
      orientation: 'horizontal',
      css: {
        '& > :where(a, button)': {
          '&:not(:first-child)': {
            marginInlineStart: 'ButtonGroup.conjoined.gap.offsetBorder',
          },
          '&:first-child:not(:only-child)': {
            borderTopRightRadius: 'ButtonGroup.conjoined',
            borderBottomRightRadius: 'ButtonGroup.conjoined',
          },
          '&:last-child:not(:only-child)': {
            borderTopLeftRadius: 'ButtonGroup.conjoined',
            borderBottomLeftRadius: 'ButtonGroup.conjoined',
          },
        },
      },
    }),

    ...ccv({
      conjoined: true,
      orientation: 'vertical',
      css: {
        '& > :where(a, button)': {
          '&:not(:first-child)': {
            marginBlockStart: 'ButtonGroup.conjoined.gap.offsetBorder',
          },
          '&:first-child:not(:only-child)': {
            borderBottomLeftRadius: 'ButtonGroup.conjoined',
            borderBottomRightRadius: 'ButtonGroup.conjoined',
          },
          '&:last-child:not(:only-child)': {
            borderTopLeftRadius: 'ButtonGroup.conjoined',
            borderTopRightRadius: 'ButtonGroup.conjoined',
          },
        },
      },
    }),
  ],
});
